import { Mail, Phone, Instagram, Facebook, Linkedin } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_dynamic-conversion/artifacts/uw2iwdym_LOGO%202.1%20X%201%20in.png";

const SOCIALS = [
  {
    label: "Instagram",
    href: "https://www.instagram.com/dynamicxmedia",
    Icon: Instagram,
    testId: "footer-social-instagram",
  },
  {
    label: "Facebook",
    href: "https://www.facebook.com/dynamicxmedia",
    Icon: Facebook,
    testId: "footer-social-facebook",
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/dynamicxmedia",
    Icon: Linkedin,
    testId: "footer-social-linkedin",
  },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-black/10 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-14 sm:py-16 flex flex-col items-center text-center gap-8">
        {/* 1. Logo — significantly larger, sharp, uncropped */}
        <img
          src={LOGO_URL}
          alt="Dynamic X Media — premium B2B marketing & branding agency logo"
          data-testid="footer-logo"
          className="block"
          style={{
            height: "100px",
            width: "auto",
            objectFit: "contain",
          }}
        />

        {/* 2. Contact links: email + WhatsApp phone */}
        <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-8 text-sm sm:text-base text-black/75">
          <a
            data-testid="footer-email"
            href="mailto:Connect@dynamicxmedia.com"
            className="inline-flex items-center gap-2 hover:text-[#2770FD] transition-colors"
          >
            <Mail className="h-4 w-4 text-[#2770FD]" />
            Connect@dynamicxmedia.com
          </a>
          <a
            data-testid="footer-phone"
            href="https://wa.me/918602265191?text=Hi%20Dynamic%20X%20Media%2C%20I%27d%20like%20to%20explore%20working%20together."
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 hover:text-[#2770FD] transition-colors"
          >
            <Phone className="h-4 w-4 text-[#2770FD]" />
            +91-86022-65191
            <span className="text-[10px] uppercase tracking-[0.2em] text-[#2770FD] ml-1 font-semibold">
              WhatsApp
            </span>
          </a>
        </div>

        {/* 3. Social icons row */}
        <div className="flex items-center gap-4">
          {SOCIALS.map(({ label, href, Icon, testId }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={label}
              data-testid={testId}
              className="group inline-flex h-10 w-10 items-center justify-center rounded-full border border-black/15 text-black hover:text-white hover:bg-[#2770FD] hover:border-[#2770FD] transition-all duration-300 hover:-translate-y-0.5"
            >
              <Icon className="h-4 w-4" strokeWidth={1.75} />
            </a>
          ))}
        </div>

        {/* 4. Copyright — absolute bottom */}
        <p
          data-testid="footer-copyright"
          className="text-xs sm:text-sm text-black/65 pt-4 border-t border-black/10 w-full max-w-3xl"
        >
          © 2026 Dynamic X Media | All rights reserved. |{" "}
          <span className="text-black">The X-Factor Agency</span>
        </p>
      </div>
    </footer>
  );
}
